import { render, staticRenderFns } from "./newDataList.vue?vue&type=template&id=764f6ba8&scoped=true"
import script from "./newDataList.vue?vue&type=script&lang=js"
export * from "./newDataList.vue?vue&type=script&lang=js"
import style0 from "./newDataList.vue?vue&type=style&index=0&id=764f6ba8&prod&lang=scss&scoped=true"
import style1 from "./newDataList.vue?vue&type=style&index=1&id=764f6ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f6ba8",
  null
  
)

export default component.exports